/* Norrviva — "Order this set" multi add-to-cart.
   Adds all the set's sample variants in one go via window.theme.cart.store
   (the same store the cart drawer subscribes to), then opens the drawer —
   same feel as the samples page. If the store isn't available it falls back
   to /cart/add.js + a full cart visit; the surrounding <form> posts to
   /cart/add as a no-JS fallback. */
(function () {
  function addSet(btn) {
    var ids = (btn.getAttribute('data-variant-ids') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean)
      .map(Number)
      .filter(function (n) { return n > 0; });
    if (!ids.length) return false;

    var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
    var original = btn.textContent;
    btn.setAttribute('disabled', '');
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = btn.getAttribute('data-adding') || 'Adding…';

    function reset() {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-busy');
      btn.textContent = original;
    }

    var store = window.theme && window.theme.cart && window.theme.cart.store;
    if (store) {
      store
        .getState()
        .add(items)
        .then(function () {
          reset();
          if (window.theme.mfpOpen) window.theme.mfpOpen('cart');
        })
        .catch(reset);
      return true;
    }

    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = cartUrl; })
      .catch(reset);
    return true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sample-set-add]');
    if (!btn) return;
    if (addSet(btn)) e.preventDefault();
  });
})();
